module.exports = __webpack_public_path__ + "7e4b29ba/img/arrow-left-icon.785c715c.svg";